/**
 * 同一份生产构建支持 ycrzky、qiyebaobao 和 yuncaifaxin 三套域名。
 * 兼容接口返回的 *.ycrzky.com 与 *-y.qiyebaobao.com 地址，
 * 按当前访问域名转换，并保留协议、端口、路径、查询参数和锚点。
 * 其他访问域名、相对地址及第三方地址保持原样。
 */
export const rewriteHost = (value) => {
  if (!value || typeof window === 'undefined') return value;
  const host = window.location.hostname;
  const sourceHost =
    /^(https?:)?\/\/([a-z0-9-]+)(?:\.ycrzky\.com|-y\.qiyebaobao\.com)(?=[:/?#]|$)/i;
  if (host === 'yuncaifaxin.com' || host.endsWith('.yuncaifaxin.com')) {
    return value.replace(sourceHost, '$1//$2.yuncaifaxin.com');
  }
  if (host === 'qiyebaobao.com' || host.endsWith('.qiyebaobao.com')) {
    return value.replace(sourceHost, '$1//$2-y.qiyebaobao.com');
  }
  if (host === 'ycrzky.com' || host.endsWith('.ycrzky.com')) {
    return value.replace(sourceHost, '$1//$2.ycrzky.com');
  }
  return value;
};
